import React from "react";
import useBranch from "../../hooks/useBranch";

const WhatsApp = () => {
  const { branch } = useBranch();

  return (
    <a
      target="_blank"
      rel="noreferrer"
      href={`https://wa.me/52${
        branch?.branch_id === 1 ? "8125159100" : "6634510006"
      }`}
      className="btn btn-success btn-whatsapp"
    >
      <i className="fab fa-whatsapp whatsapp-btn-icon" aria-hidden />
      <span className="btn-whatsapp-text hide-mobile">Ayuda</span>
    </a>
  );
};
export default WhatsApp;
